import { hasPermission, type ActionKey, type AuthUser, type ModuleKey } from '@fluxus/shared';

/** O perfil pode fazer a ação no módulo? (matriz de permissões da empresa — RN-24, T-024). */
export function can(user: Pick<AuthUser, 'permissions'>, module: ModuleKey, action: ActionKey): boolean {
  return hasPermission(user.permissions, module, action);
}

/** O módulo aparece para o perfil (tem "visualizar")? */
export function canAccess(user: Pick<AuthUser, 'permissions'>, module: ModuleKey): boolean {
  return can(user, module, 'view');
}

/** Tela inicial do perfil: Fluxus → Central de Empresas; clientes → Visão Geral da empresa. */
export function homePathFor(user: Pick<AuthUser, 'permissions' | 'organization'>): string {
  if (user.organization.isFluxus && canAccess(user, 'central-empresas')) return '/empresas';
  if (!user.organization.isFluxus && canAccess(user, 'visao-geral')) return '/visao-geral';
  return '/sem-acesso';
}

/** Só aceita voltar para um caminho interno do app (nunca para outro site). */
export function safeReturnPath(value: string | null | undefined): string | null {
  // Caracteres de controle: o navegador remove tab/quebra de linha da URL ("/\t/site" vira "//site").
  if (!value || !value.startsWith('/') || hasControlChar(value)) return null;
  // Resolve como o navegador faria e exige a mesma origem ("//site" e "/\site" são outro domínio).
  const base = 'https://app.fluxus.invalid';
  let url: URL;
  try {
    url = new URL(value, base);
  } catch {
    return null;
  }
  if (url.origin !== base) return null;
  if (url.pathname === '/entrar' || url.pathname.startsWith('/entrar/')) return null;
  return `${url.pathname}${url.search}${url.hash}`;
}

function hasControlChar(value: string): boolean {
  for (let i = 0; i < value.length; i++) {
    const code = value.charCodeAt(i);
    if (code <= 0x1f || code === 0x7f) return true;
  }
  return false;
}
